import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MatFormFieldAppearance } from "@angular/material/form-field";
import { ToolsService } from "../../services/tools.service";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};

@Component({
  selector: "select-date",
  templateUrl: "select-date.html",
  styleUrls: ["select-date.scss"],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "fr" },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false,
})
export class SelectDate implements OnInit {
  @Input() value: Date;
  @Input() title?: string = "Date";
  @Input() disabled?: boolean = false;
  @Input() nbDays?: number = 0;
  @Input() bFullWidth?: boolean = false;

  @Output() valueChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();

  public bMobile: boolean;

  constructor(private _tools: ToolsService) {}

  ngOnInit(): void {
    this.bMobile = this._tools.isMobileSupport();
  }

  change(val: any): void {
    let d;
    try {
      d = this._tools.dateUTC(new Date(val));
    } catch (ex) {
      return;
    }

    this.valueChange.emit(d);
    this.selectionChange.emit();
  }
}
